import * as z from 'zod/mini'
import { queryArray } from '../schemas/common'

/**
 * `?userIds=` - the users (the caller or child users they manage) a client request is for. One user
 * for now; the limit goes when child users are reintroduced. `ManagedUsersGuard` checks the caller
 * may act for each of them.
 */
export const selectUsersQuery = z.object({
  userIds: queryArray(z.array(z.uuid()).check(z.minLength(1), z.maxLength(1))),
})
export type SelectUsersQuery = z.infer<typeof selectUsersQuery>
